import { render, staticRenderFns } from "./selected.vue?vue&type=template&id=6335a9fa&scoped=true"
import script from "./selected.vue?vue&type=script&lang=js"
export * from "./selected.vue?vue&type=script&lang=js"
import style0 from "./selected.vue?vue&type=style&index=0&id=6335a9fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335a9fa",
  null
  
)

export default component.exports